(ns lupapalvelu.application)

(def operations-path-for-toteuttamislupa "Rakentaminen ja purkaminen")
